import { toNumber, isNumber, isNaN } from 'lodash';

export const NumberUtil = {
  formatNumberAsDecimal(value, decimalPlaces = 2) {
    const number = toNumber(value);

    return isNumber(number) ? number.toFixed(decimalPlaces) : null;
  },
  formatAsHours(hours) {
    if (typeof hours !== 'string' && typeof hours !== 'number') {
      return null;
    }

    if (hours === null || hours === undefined) {
      return null;
    }

    hours = toNumber(hours);
    if (isNaN(hours)) {
      return null;
    }

    hours = Math.floor(hours);

    return hours === 1 ? '1 hr' : `${hours} hrs`;
  },
};
